import { render, staticRenderFns } from "./Desacumulados.vue?vue&type=template&id=ae163de2&scoped=true"
import script from "./Desacumulados.vue?vue&type=script&lang=js"
export * from "./Desacumulados.vue?vue&type=script&lang=js"
import style0 from "./Desacumulados.vue?vue&type=style&index=0&id=ae163de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae163de2",
  null
  
)

export default component.exports